<template>
  <div class="row justify-content-between mt-3 mb-4">
    <div class="col-md-10">
      <div class="white-card mr-0 p-3 relative-container">
        <div class="mb-0">
          <div class="col">
            <LotNavigation
              :current-section.sync="currentLot"
              :general-tab-index="-1"
              :general-tab-label="'operationConstruction.general'"
              :lot-prefix="$t('OperationLot')"
              :lots="operationLots"
              :new-label="$t('New')"
              :operation-lot-label="$t('operationLot')"
              :show-general-tab="true"
              :show-new-label="true"
              :use-value-property="false"
            />
          </div>
        </div>

          <b-container fluid>
            <b-row>
              <b-col v-if="currentLot === -1">
                <div v-for="typeConstruction in typesConstruction">
                  <div class="row my-2">
                    <div class="col-md-12">
                      <span class="section-subtitle">{{ $t(typeConstruction.text) }}</span>
                    </div>
                  </div>

                  <template v-for="operationConstruction in operationConstructions">
                    <div
                      v-if="((operationConstruction.data.operation !== null && operationConstruction.data.operation.id === operationId) || ( operationConstruction.selectedLots.length !== 0)) && operationConstruction.data.typeConstruction.value === typeConstruction.value">
                      <operation-construction-component
                        :index="operationConstructions.indexOf(operationConstruction)"
                        :is-create-bilan="true"
                        :is-general="true"
                        :is-h-t="isHT"
                        :operation-construction="operationConstruction.data"
                        :operation-lots="operationLots"
                        :selected-lots="operationConstruction.selectedLots"
                        @didChangeValue="emitChangeValue"
                        @editedOperationConstruction="editedOperationConstruction"
                        @removedOperationConstruction="removedOperationConstruction"
                      />
                    </div>
                  </template>


                  <div class="row mt-2 mb-4">
                    <div class="col-md-12">
                      <span class="bold-text addLink"
                            @click="addOperationConstructionGeneral(operation, typeConstruction)"> + {{
                          $t('Add')
                        }} {{ $t(typeConstruction.text) }}</span>
                    </div>
                  </div>

                </div>
              </b-col>
              <b-col v-for="(operationLot, index) in operationLots" v-if="currentLot === index"
                     :key="index + '-content-key'">
                <div v-for="typeConstruction in typesConstruction">
                  <div class="row">
                    <div class="col-md-12">
                      <span class="section-subtitle">{{ $t(typeConstruction.text) }}</span>
                    </div>
                  </div>

                  <template v-for="operationConstruction in operationConstructions">
                    <operation-construction-component
                      v-if="operationConstruction.data.operationLot != null && (operationConstruction.data.operationLot.id === operationLot.id && operationConstruction.selectedLots.length === 0 ) && operationConstruction.data.typeConstruction.value === typeConstruction.value"
                      :index="operationConstructions.indexOf(operationConstruction)"
                      :is-create-bilan="true"
                      :is-h-t="isHT"
                      :operation-construction="operationConstruction.data"
                      @didChangeValue="emitChangeValue"
                      @editedOperationConstruction="editedOperationConstruction"
                      @removedOperationConstruction="removedOperationConstruction"
                    />
                  </template>

                  <div class="row mt-2 mb-4">
                    <div class="col-md-12">
                      <span class="bold-text addLink"
                            @click="addOperationConstruction(operationLot, typeConstruction)"> + {{
                          $t('Add')
                        }} {{ $t(typeConstruction.text) }}</span>
                    </div>
                  </div>

                </div>
              </b-col>
            </b-row>
          </b-container>

          <div class="d-flex justify-content-end">
            <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
            <b-button type="submit" variant="primary" @click="onSubmit">{{ $t('Continue') }}</b-button>
          </div>
      </div>
    </div>

    <div class="col-md-2">
      <OperationBilanCardPrice
        :prices="totalPrices">
      </OperationBilanCardPrice>
    </div>

    <add-operation-construction-modal
      v-if="isLoading === false"
      ref="addOperationConstructionModalCreateBilan"
      :all-initial-date-operation-and-lot="allInitialDateOperationAndLot"
      :is-h-t="isHT"
      :operation="selected.operation"
      :operation-lots="operationLots"
      :operationLot="selected.operationLot"
      :taux-t-v-a-list="tauxTVAList"
      :type-construction="selected.typeConstruction"
      :unites-construction="unitesConstruction"
      @didAddOperationConstruction="didAddOperationConstruction"/>

    <edit-operation-construction-modal
      v-if="isLoading === false && selected.operationConstruction && selected.operationConstruction.data && selected.operationConstruction.data.hasOwnProperty('id')"
      ref="editOperationConstructionModal"
      :is-h-t="isHT"
      :operation-construction="selected.operationConstruction"
      :operation-lots="operationLots"
      :status-facture-list="statusFactureList"
      :taux-t-v-a-list="tauxTVAList"
      :type-construction="selected.typeConstruction"
      @didEditOperationConstruction="didEditOperationConstruction"/>

  </div>
</template>

<script>

import api from '../../../services/api'
import OperationBilanCardPrice from "./components/OperationBilanCardPrice.vue";
import OperationConstructionComponent from "../components/OperationConstructionComponent.vue";
import AddOperationConstructionModal from "../components/AddOperationConstructionModal.vue";
import EditOperationConstructionModal from "../components/EditOperationConstructionModal.vue";
import LotNavigation from "../../../components/LotNavigation";
import {v4 as uuidv4} from "uuid";


export default {
  name: "OperationBilanConstruction",

  components: {
    OperationBilanCardPrice,
    OperationConstructionComponent,
    AddOperationConstructionModal,
    EditOperationConstructionModal,
    LotNavigation
  },

  props: {
    operationId: {
      type: Number,
      default: null
    },
    simulationId: {
      type: Number,
      default: null
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      operationBilanId: null,
      unsavedChanges: [],
      typesConstruction: [],
      unitesConstruction: [],
      operationLots: [],
      operation: null,
      currentLot: -1,
      operationConstructions: [],
      allInitialDateOperationAndLot: [],
      selected: {
        operation: null,
        operationLot: null,
        typeConstruction: null,
        operationConstruction: {}
      },
      operationConstructionsIdsToRemove: [],
      totalPrices: [],
      tauxTVAList: [],
      statusFactureList: [],
      isLoading: false,
    }
  },

  emits: ['didContinue', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
    if (this.operationLots.length === 1) {
      this.currentLot = 0;
    }
  },

  methods: {
    async fetchData() {
      this.isLoading = true
      await this.getOperationBilanId()
      await this.getTotalOfBilan()
      await this.getTypesConstruction()
      await this.getUnitesConstruction()
      await this.getOperationLots()
      await this.getOperation()
      await this.getAllInitialDateOperationAndLot()
      await this.getTauxTVA()
      await this.getStatusFacture()
      await this.getOperationConstructions()
      this.isLoading = false

    },

    async getTauxTVA() {
      await api
        .get(`/operation/getTauxTVA`)
        .then(response => {
          this.tauxTVAList = response.data
        })
    },
    async getStatusFacture() {
      await api
        .get(`/facturePayment/getStatusFacture`)
        .then(response => {
          this.statusFactureList = response.data
        })
    },

    async getTypesConstruction() {
      await api
        .get(`/simulationConstruction/getTypesConstruction`)
        .then(response => {
          this.typesConstruction = response.data
        })
    },

    toggleLotSelection(operationConstruction, lotId) {
      const index = operationConstruction.selectedLots.indexOf(lotId);
      if (index === -1) {
        operationConstruction.selectedLots.push(lotId);
      } else {
        operationConstruction.selectedLots.splice(index, 1);
      }
      if (!this.unsavedChanges.includes(operationConstruction.uuid)) {
        this.unsavedChanges.push(operationConstruction.uuid)
      }
    },

    async getUnitesConstruction() {
      await api
        .get(`/simulationConstruction/getUnitesConstruction`)
        .then(response => {
          this.unitesConstruction = response.data
        })
    },

    async getOperationBilanId() {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationLots() {
      if (this.operationId != null) {
        await api
          .get(`/operationLot/getAllForOperation/${this.operationId}`)
          .then(response => {
            this.operationLots = response.data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 1,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.operation = response.data
          })
      }
    },

    formatDate(dateLong) {
      return new Date(Number(dateLong)).toLocaleDateString().split("/").reverse().join("-");
    },

    getInitialDate(source, id, type, dateType) {
      let dateLong = source[type].find(x => x.id === id)[dateType];
      if (dateLong != null) {
        return this.formatDate(dateLong);
      }
      return null;
    },

    async getAllInitialDateOperationAndLot() {
      await api
        .get(`/operation/getAllInitialDateOperationAndLot/${this.operationId}`)
        .then(response => {
          this.allInitialDateOperationAndLot = response.data
        })
        .catch((error) => {

        })
    },

    async getOperationConstructions() {
      if (this.operationId != null) {
        await api
          .get(`/operationConstruction/getAllForOperation/${this.operationId}`)
          .then(response => {
            const tempConstructions = {}

            response.data.forEach(construction => {
              if (construction['date'] != null) {
                construction['date'] = this.formatDate(construction['date']);
              } else {
                let date = null;
                if (construction.operationLot.id != null) {
                  date = this.getInitialDate(this.allInitialDateOperationAndLot, construction.operationLot.id, "operationLots", "estimatedStartDate");
                }
                if (date == null) {
                  date = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionStartDate);
                }
                construction['date'] = date;
              }
              construction['dateState'] = null
              if (construction['endDate'] != null) {
                construction['endDate'] = this.formatDate(construction['endDate']);
              } else {
                let date = null;
                if (construction.operationLot.id != null) {
                  date = this.getInitialDate(this.allInitialDateOperationAndLot, construction.operationLot.id, "operationLots", "estimatedEndDate");
                }
                if (date == null) {
                  date = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionEndDate);
                }
                construction['endDate'] = date;
              }
              construction['endDateState'] = null
              if (construction.commonId && construction.commonId !== '') {
                if (!tempConstructions[construction.commonId]) {
                  tempConstructions[construction.commonId] = {
                    data: construction,
                    selectedLots: []
                  }
                }
                tempConstructions[construction.commonId].selectedLots.push(construction.operationLot.id)
              } else {
                tempConstructions[construction.id] = {
                  data: construction,
                  selectedLots: construction.operation.id ? this.operationLots.map(lot => lot.id) : []
                }
              }
            })
            this.operationConstructions = Object.values(tempConstructions)
            this.operationConstructions.forEach(construction => {
              if (this.isHT && construction['data']['tauxTVA']) {
                construction['data']['prixParM2'] = this.convertTTCtoHT(
                  construction['data']['prixParM2'],
                  construction['data']['tauxTVA']
                );
              }

              if (construction['data']['commonId'] != null) {
                construction['data']['prixParM2'] = Math.round(construction['data']['prixParM2'] * construction['selectedLots'].length)
                construction['data']['prixParM2HT'] = Math.round(construction['data']['prixParM2HT'] * construction['selectedLots'].length)
                construction['data']['prixTTC'] = construction['data']['surface'] ? construction['data']['surface'] * construction['data']['prixParM2'] : construction['data']['prixParM2']
                construction['data']['prixHT'] = construction['data']['surface'] ? construction['data']['surface'] * construction['data']['prixParM2HT'] : construction['data']['prixParM2HT']
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    convertTTCtoHT(prixTTC, tauxTVA) {
      if (!prixTTC || !tauxTVA) return prixTTC;
      const taux = parseFloat(tauxTVA.replace('%', '')) / 100;
      return prixTTC / (1 + taux);
    },


    async emitChangeValue(operationConstruction) {
      let startDateValid = true;
      let endDateValid = true;

      if (operationConstruction.date > operationConstruction.endDate) {
        operationConstruction.dateState = false;
        operationConstruction.endDateState = false;
        this.toast(`${operationConstruction.name}: La date de début doit être inférieure à la date de fin`, 'danger');
      } else {
        operationConstruction.dateState = null;
        operationConstruction.endDateState = null;

        if (operationConstruction.operation && operationConstruction.operation.id) {
          // Validation against the operation's initial dates
          let opStartDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionStartDate);
          let opEndDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionEndDate);
          startDateValid = operationConstruction.date >= opStartDate && operationConstruction.date <= opEndDate;
          endDateValid = operationConstruction.endDate >= opStartDate && operationConstruction.endDate <= opEndDate;
        } else if (operationConstruction.operationLot && operationConstruction.operationLot.id) {
          // Validation against the operationLot's initial dates
          let lotStartDate = this.getInitialDate(this.allInitialDateOperationAndLot, operationConstruction.operationLot.id, "operationLots", "estimatedStartDate");
          let lotEndDate = this.getInitialDate(this.allInitialDateOperationAndLot, operationConstruction.operationLot.id, "operationLots", "estimatedEndDate");

          if (!lotStartDate || !lotEndDate) {
            // Fallback to operation dates if operationLot dates are null
            lotStartDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionStartDate);
            lotEndDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionEndDate);
          }

          startDateValid = operationConstruction.date >= lotStartDate && operationConstruction.date <= lotEndDate;
          endDateValid = operationConstruction.endDate >= lotStartDate && operationConstruction.endDate <= lotEndDate;
        }
        if (!startDateValid || !endDateValid) {
          this.toast(`${operationConstruction.name}:  Les dates ne sont pas comprises entre les dates initiales prévues pour l'opération ou le lot d'opération`, 'info');
          operationConstruction.dateState = false;
          operationConstruction.endDateState = false;
        }
      }

      console.log('operationConstruction', operationConstruction)
      console.log('this.operationConstructions', this.operationConstructions)
      if (operationConstruction.date && operationConstruction.endDate && operationConstruction.endDate >= operationConstruction.date) {
        let index = this.operationConstructions.findIndex((obj) => JSON.stringify(obj.data) === JSON.stringify(operationConstruction));
        console.log('index', index)
        if (index > -1) {
          await this.createOrUpdateOperationConstructions(this.operationConstructions[index])
        }
      }
      this.$emit('didChangeValue')
    },

    addOperationConstruction(operationLot, typeConstruction) {
      this.selected.operationLot = operationLot
      this.selected.operation = null
      this.selected.typeConstruction = typeConstruction
      this.$refs.addOperationConstructionModalCreateBilan.uniteConstruction = this.unitesConstruction[0].value
      this.$bvModal.show('add-operation-construction-modal')
    },

    addOperationConstructionGeneral(operation, typeConstruction) {
      this.selected.operation = operation
      this.selected.operationLot = null
      this.selected.typeConstruction = typeConstruction
      this.$refs.addOperationConstructionModalCreateBilan.uniteConstruction = this.unitesConstruction[0].value
      this.$bvModal.show('add-operation-construction-modal')
    },

    async didAddOperationConstruction(operationConstruction) {
      let operationLotsIds = []
      let date = null
      let endDate = null
      let uuid = uuidv4()
      let tauxTVA = "20%"

      if (this.selected.operation != null) {
        operationConstruction.selectedLots.sort((a, b) => a - b)
        operationConstruction.selectedLots.forEach(lot => {
          operationLotsIds.push(lot)
        });
      }
      delete operationConstruction.selectedLots

      date = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionStartDate);
      endDate = this.formatDate(this.allInitialDateOperationAndLot["operation"].constructionEndDate);
      if (this.selected.operationLot != null) {
        if (this.getInitialDate(this.allInitialDateOperationAndLot, this.selected.operationLot.id, "operationLots", "estimatedStartDate")) {
          date = this.getInitialDate(this.allInitialDateOperationAndLot, this.selected.operationLot.id, "operationLots", "estimatedStartDate")
          endDate = this.getInitialDate(this.allInitialDateOperationAndLot, this.selected.operationLot.id, "operationLots", "estimatedEndDate")
        }
      }

      if (operationConstruction.tauxTVA) {
        tauxTVA = operationConstruction.tauxTVA
      }
      if (operationConstruction.date) {
        date = operationConstruction.date
      }
      if (operationConstruction.endDate) {
        endDate = operationConstruction.endDate
      }


      this.selected.operation = null
      this.selected.operationLot = null
      this.selected.typeConstruction = null
      const operationConstructionToAdd = {
        ...operationConstruction,
        tauxTVA,
        date,
        endDate,
        uuid
      }
      this.operationConstructions.push({
        data: {...operationConstructionToAdd},
        selectedLots: operationLotsIds
      });
      this.$refs.addOperationConstructionModalCreateBilan.uniteConstruction = this.unitesConstruction[0].value
      await this.emitChangeValue(this.operationConstructions[this.operationConstructions.length - 1].data)
      if (!this.unsavedChanges.includes(operationConstructionToAdd.uuid)) {
        this.unsavedChanges.push(operationConstructionToAdd.uuid)
      }
    },

    editedOperationConstruction(operationConstruction) {
      if (operationConstruction) {
        let operationConstructionFullData = this.operationConstructions.find((obj) => obj.data.id === operationConstruction.id)
        if (operationConstructionFullData) {
          this.selected.operationConstruction = operationConstructionFullData
          this.selected.typeConstruction = operationConstruction.typeConstruction
          this.$nextTick(() => {
            this.$bvModal.show('edit-operation-construction-modal')
          });
        }
      }
    },


    async didEditOperationConstruction(operationConstruction) {
      if (!operationConstruction.data.date) {
        operationConstruction.data.dateState = false
      }
      if (!operationConstruction.data.endDate) {
        operationConstruction.data.endDateState = false
      }
      if (!operationConstruction.data.date || !operationConstruction.data.endDate) {
      } else if (operationConstruction.data.date && operationConstruction.data.endDate && operationConstruction.data.date > operationConstruction.data.endDate) {
        operationConstruction.data.dateState = false
        operationConstruction.data.endDateState = false
      }
      this.selected.operationConstruction = operationConstruction
      await this.emitChangeValue(operationConstruction.data)

      this.selected.operationConstruction = {}
    },

    async removedOperationConstruction(operationConstruction) {
      console.log('removedOperationConstruction', operationConstruction)
      let index = this.operationConstructions.findIndex((obj) => JSON.stringify(obj.data) === JSON.stringify(operationConstruction));
      if (operationConstruction.id) {
        this.isLoading = true
        await this.deleteOperationConstructions(operationConstruction)
        await this.getTotalOfBilan()
        this.isLoading = false
      }
      console.log('indexremovedOperationConstruction', index)
      if (index > -1) {
        this.operationConstructions.splice(index, 1);
      }
    },

    async getTotalOfBilan() {
      await api
        .get(`/operationBilan/getTotalOfBilan/${this.operationId}`)
        .then(response => {
          this.totalPrices = response.data
        })
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      });
    },

    async onSubmit() {
      let invalid = []
      for (let operationConstruction of this.operationConstructions) {
        if (!operationConstruction.data.date) {
          operationConstruction.data.dateState = false
        }
        if (!operationConstruction.data.endDate) {
          operationConstruction.data.endDateState = false
        }
        if (!operationConstruction.data.date || !operationConstruction.data.endDate) {
          invalid.push(operationConstruction)
        } else if (operationConstruction.data.date && operationConstruction.data.endDate && operationConstruction.data.date > operationConstruction.data.endDate) {
          operationConstruction.data.dateState = false
          operationConstruction.data.endDateState = false
          invalid.push(operationConstruction)
        }
      }
      if (invalid.length > 0) {
        return
      }
      await this.editOperationBilan()
      this.$emit('didContinue', this.operationId, this.operationBilanId)
    },

    async createOrUpdateOperationConstructions(operationConstruction) {
      let success = true
      let data = new FormData()
      if (operationConstruction.data.operationLot != null) {
        data.append('operationLotId', operationConstruction.data.operationLot.id)
      }
      if (operationConstruction.data.operation != null) {
        data.append('operationId', operationConstruction.data.operation.id)
        data.append('selectedLotsIds', operationConstruction.selectedLots)
      }
      data.append('name', operationConstruction.data.name)
      data.append('contactName', operationConstruction.data.contactName)
      data.append('typeConstruction', operationConstruction.data.typeConstruction.value)
      data.append('uniteConstruction', operationConstruction.data.uniteConstruction.value)
      data.append('surface', operationConstruction.data.surface)
      data.append('tauxTVA', operationConstruction.data.tauxTVA)
      data.append('ordre', operationConstruction.data.ordre ? operationConstruction.data.ordre : 0)

      let prixParM2ToSend = this.operation.isHT ? operationConstruction.data.prixParM2HT : operationConstruction.data.prixParM2;
      if (this.operation && this.operation.isHT && operationConstruction.data.tauxTVA) {
        const taux = parseFloat(operationConstruction.data.tauxTVA.replace('%', '')) / 100;
        prixParM2ToSend = operationConstruction.data.prixParM2HT * (1 + taux);
      }

      data.append('prixParM2', prixParM2ToSend)
      if (operationConstruction.data.pourcentage !== null && operationConstruction.data.pourcentage !== undefined) {
        data.append('pourcentage', operationConstruction.data.pourcentage)
        console.log('[DEBUG] Ajout du pourcentage au FormData:', operationConstruction.data.pourcentage)
      }

      operationConstruction.data.devis.forEach((devis, indexDevis) => {
        let devisCopy = {...devis};
        delete devisCopy.documents;

        data.append(`devis[${indexDevis}]`, JSON.stringify(devisCopy));
        if (devis && devis.documents && devis.documents.length > 0) {
          devis.documents.forEach((document, indexDocument) => {
            if (document) {
              if (document instanceof File) {
                data.append(`devisDocuments[${indexDevis}][${indexDocument}]`, document);
              } else {
                if (document && document.id) {
                  data.append(`devisDocumentsAlreadyInDb[${indexDevis}][${indexDocument}]`, document.id);
                }
              }
            }
          });
        }
      });
      if (operationConstruction.data && operationConstruction.data.hasOwnProperty("factures") && operationConstruction.data.factures && operationConstruction.data.factures.length > 0) {
        operationConstruction.data.factures.forEach((facture, indexFacture) => {
          let factureCopy = {...facture};
          delete factureCopy.documents;

          data.append(`facture[${indexFacture}]`, JSON.stringify(factureCopy));
          if (facture && facture.documents && facture.documents.length > 0) {
            facture.documents.forEach((document, indexDocument) => {
              if (document) {
                if (document instanceof File) {
                  data.append(`factureDocuments[${indexFacture}][${indexDocument}]`, document);
                } else {
                  if (document && document.id) {
                    data.append(`factureDocumentsAlreadyInDb[${indexFacture}][${indexDocument}]`, document.id);
                  }
                }
              }
            });
          }
        });
      }

      if (operationConstruction.data.date) {
        data.append('date', operationConstruction.data.date)
      }
      if (operationConstruction.data.endDate) {
        data.append('endDate', operationConstruction.data.endDate)
      }

      let url = 'operationConstruction'
      if (operationConstruction.data.id) {
        url = '/operationConstruction/' + operationConstruction.data.id
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          operationConstruction.data = {
            ...operationConstruction.data,
            id: response.data.id,
            prixParM2: response.data.prixParM2,
            prixTTC: response.data.prixTTC,
            remainingTTC: response.data.remainingTTC,
            prixHT: response.data.prixHT,
            remainingHT: response.data.remainingHT,
            prixParM2HT: response.data.prixParM2HT
          }

          if (this.operation && this.operation.isHT && operationConstruction.data.tauxTVA) {
            operationConstruction.data.prixParM2 = this.convertTTCtoHT(
              operationConstruction.data.prixParM2,
              operationConstruction.data.tauxTVA
            );
          }

          if (operationConstruction.data.commonId != null) {
            operationConstruction.data.prixParM2 = Math.round(operationConstruction.data.prixParM2 * operationConstruction.selectedLots.length);
            operationConstruction.data.prixParM2HT = Math.round(operationConstruction.data.prixParM2HT * operationConstruction.selectedLots.length);
            operationConstruction.data.prixTTC = operationConstruction.data.surface
              ? operationConstruction.data.surface * operationConstruction.data.prixParM2
              : operationConstruction.data.prixParM2;
            operationConstruction.data.prixHT = operationConstruction.data.surface
              ? operationConstruction.data.surface * operationConstruction.data.prixParM2HT
              : operationConstruction.data.prixParM2HT;
          }

          this.$bvToast.toast(this.$i18n.t('OperationConstruction') + " " + this.$i18n.t('f.registered.object'), {
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            noCloseButton: true,
            variant: 'success',
            solid: true,
          })
        })
        .catch((error) => {
          success = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
      return success
    },

    async deleteOperationConstructions(operationConstruction) {
      if (operationConstruction) {
        await api
          .delete(`/operationConstruction/${operationConstruction.id}`)
      }
    },

    async editOperationBilan() {

      let data = new FormData()
      data.append('constructionDone', true)

      api({
        method: 'POST',
        url: '/operationBilan/' + this.operationBilanId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    toast(message, variant) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: variant,
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
.custom-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: -1em;
}

.custom-container > * {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanCreateEditSteps/OperationBilanConstruction.vue